module.exports = __webpack_public_path__ + "img/FORMULARIO-TU-PLANTA-ENFERMA.145fc73d.png";